import React from 'react';
import styled, {css} from "styled-components";

export const StyledBlock = styled.div`
  background: #F5F7FB !important;
  border: 1px solid #C4D6E9 !important;
  border-radius: 0.5714285714285714rem !important;
  padding: 21px;

  h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 27px;
    display: flex;
    align-items: center;

    color: #459EFF;
  }
  
  .setting:nth-child(1) {
    margin-bottom: 15px;
  }
`

const CardBlock = ({children}) => {
    return (
        <StyledBlock $borderRadiusTop={!children}>
            {children}
        </StyledBlock>
    );
};

export default CardBlock;


// WEBPACK FOOTER //
// ./App/components/CardBlock.jsx